import React from "react";
import { Col, Row } from "reactstrap";

interface Props {
  Rows: number;
  ColumnPerRow: number;
}
class TableLoader extends React.Component<Props> {
  getIndividualContent = () => {
    const { Rows, ColumnPerRow } = this.props;
    let contentRow = [];
    if (Rows && Rows > 1 && ColumnPerRow && ColumnPerRow > 1) {
      let no_of_cols = 12 / ColumnPerRow;
      no_of_cols = Math.floor(12 / no_of_cols);
      for (let i = 0; i < Rows; i++) {
        let contentColumn = [];
        for (let j = 0; j < no_of_cols; j++) {
          contentColumn.push(
            <Col>
              <div className="line"></div>
            </Col>
          );
        }
        contentRow.push(<Row className="row mt-3 mb-3">{contentColumn}</Row>);
      }
    } else if (Rows > 0 && !ColumnPerRow) {
      for (let i = 0; i < Rows; i++) {
        contentRow.push(
          <Row className="row mt-3 mb-3">
            <Col>
              <div className="line"></div>
            </Col>
          </Row>
        );
      }
    } else {
      contentRow.push(
        <Row className="row mt-3 mb-3">
          <Col>
            <div className="line"></div>
          </Col>
        </Row>
      );
    }
    return contentRow;
  };

  render() {
    return <div className="loaderContainer">{this.getIndividualContent()}</div>;
  }
}

export default TableLoader;
